"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectDevice = void 0;
const constants_1 = require("../constants");
const parseUserAgent_1 = require("./parseUserAgent");
function detectDevice() {
    const userAgent = navigator.userAgent;
    const nativeWebviewRegex = /((wv|sdk) \([^\)]+\))|WebView/i;
    if (nativeWebviewRegex.test(userAgent) || (0, parseUserAgent_1.isWebView)()) {
        return constants_1.Device.WEBVIEW;
    }
    else if ((0, parseUserAgent_1.isMobile)()) {
        return constants_1.Device.MOBILE;
    }
    else if ((0, parseUserAgent_1.isDesktopOs)()) {
        return constants_1.Device.DESKTOP;
    }
    else {
        return constants_1.Device.UNKNOWN;
    }
}
exports.detectDevice = detectDevice;
